import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { getAuctions } from '../../slices/auctionsSlice';
import AuctionsComp from '../../components/auctions';
import LoaderCP from '../../components/loader';

const AuctionsSection = () => {
  const dispatch = useDispatch();
  const { auctions, status } = useSelector((state) => state.auctions);

  useEffect(() => {
    dispatch(getAuctions());
  }, []);

  return (
    <div className="bg-white">
      {status === 'loading' ? <LoaderCP /> : ''}
      {auctions.length > 0
        ? <AuctionsComp items={auctions} />
        : '' }
    </div>
  );
};

export default AuctionsSection;
